<template>
  <v-tab-item :value="$route.path" class="pa-3">
    <v-toolbar flat height="90">
      <v-col class="pa-0">
        <ExportLinks export-key="company-gift-vouchers" />
      </v-col>

      <v-spacer></v-spacer>

      <v-col cols="4">
        <b-search-field v-model="search"></b-search-field>
      </v-col>
    </v-toolbar>
    <b-data-table
      :headers="headers"
      :items="vouchers"
      :page.sync="page"
      @page-sync="(p) => (page = p)"
      class="b-outlined"
    >
      <template v-slot:no-data>
        {{ translations.noData[lang] }}
      </template>
      <template v-slot:item.redemption_date="{ item }">
        {{ formatDate(item.redemption_date) }}
      </template>
    </b-data-table>
  </v-tab-item>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import translations from '@/utils/translations/loyaltyPanel/redemptions';
import ExportLinks from '@/components/general/ExportLinks.vue';
import debounce from 'lodash/debounce';
import moment from 'moment';

export default {
  name: 'Vouchers',

  mixins: [translations],

  components: {
    ExportLinks,
  },

  data() {
    return {
      page: +this.$route.query.page,
      search: '',
    };
  },

  computed: {
    ...mapState(['loading', 'serverItemsLength']),
    ...mapState('loyaltyPanel/redemptions', ['vouchers']),

    headers() {
      return [
        {
          text: this.translations.voucherName[this.lang],
          value: 'gift_title',
        },
        {
          text: this.translations.cost[this.lang],
          value: 'cost',
        },
        {
          text: this.translations.redemptionDate[this.lang],
          value: 'redemption_date',
        },
        {
          text: this.translations.voucherMobile[this.lang],
          value: 'mobile',
        },
        {
          text: this.translations.redemptionStore[this.lang],
          value: 'store_name',
        },
        {
          text: this.translations.redemptionStoreCode[this.lang],
          value: 'store_code',
        },
      ];
    },

    lang() {
      return this.$route.params.lang;
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/redemptions', ['fetchVouchers']),

    handleSearch() {
      let q = this.query;
      if (this.search?.length) {
        q += `&q=${this.search}`;
      }
      this.fetchVouchers(q);
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
  },

  mounted() {
    this.fetchVouchers(this.query);
  },

  watch: {
    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.debouncedSearch();
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

    query() {
      this.debouncedSearch();
    },

    search(val) {
      this.page = 1;
      this.debouncedSearch();
    },
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },
};
</script>
